// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomCreativeJuiceBox = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.66625 2.22281C4.66625 1.73193 5.0642 1.33398 5.55508 1.33398H9.99922C10.4901 1.33398 10.888 1.73193 10.888 2.22281V3.20555C10.888 3.31884 10.9169 3.43026 10.9719 3.52929L12.1374 5.62712C12.1924 5.72616 12.2213 5.83757 12.2213 5.95086V6.66695V13.7776V13.9998C12.2213 14.3679 11.9228 14.6664 11.5547 14.6664H11.3325H4.22184H3.99963C3.63146 14.6664 3.33301 14.3679 3.33301 13.9998V13.7776V6.66695V5.95086C3.33301 5.83757 3.36188 5.72615 3.4169 5.62712L4.58236 3.52929C4.63738 3.43026 4.66625 3.31884 4.66625 3.20555V2.22281ZM9.5548 2.22281C9.80025 2.22281 9.99922 2.42178 9.99922 2.66723C9.99922 2.91267 9.80025 3.11164 9.5548 3.11164H5.99949C5.75405 3.11164 5.55508 2.91267 5.55508 2.66723C5.55508 2.42178 5.75405 2.22281 5.99949 2.22281H9.5548ZM5.72962 4.00047C5.48752 4.00047 5.26446 4.13172 5.14689 4.34335L4.34979 5.77812H11.2045L10.4074 4.34335C10.2898 4.13172 10.0667 4.00047 9.82465 4.00047H5.72962ZM4.22184 7.33357C4.22184 6.96541 4.52029 6.66695 4.88846 6.66695H10.6658C11.034 6.66695 11.3325 6.96541 11.3325 7.33357V13.111C11.3325 13.4791 11.034 13.7776 10.6658 13.7776H4.88846C4.52029 13.7776 4.22184 13.4791 4.22184 13.111V7.33357Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('circle', {
      cx: '7.77721',
      cy: '9.99986',
      r: '1.4999',
      stroke: 'currentColor',
      strokeWidth: '0.999931',
    }),
  );

export { IconCustomCreativeJuiceBox };
